define.alias("shared/components/shared/video-thumbnail-list", "media/components/shared/video-thumbnail-list");